import { IQuestionsGroup } from './faq-item';

export interface IFaqSave {
    main_content: string;
    groups: IQuestionsGroup[];
}
